import {Props} from './model';
import * as React from 'react';
import {View} from 'react-native';
import {SurveyCongratsMessage} from '../components/surveyCongratsMessage';
import {useStyles} from '../../../shared/hooks/styles';
import Screen from '../../../shared/components/screen';
import {useTheme} from '../../../shared/theme';

export default ({}: Props) => {
  const theme = useTheme();
  const styles = useStyles(() => ({
    sectionContainer: {
      paddingTop: 100,
      paddingBottom: theme.screen.bottomOffset,
      minHeight: 600,
      paddingHorizontal: 20,
      flex: 1,
      position: 'relative',
      zIndex: 1,
    },
    scrollView: {
      flex: 1,
    },
  }));
  return (
    <Screen style={styles.scrollView}>
      <View style={styles.sectionContainer}>
        <SurveyCongratsMessage />
      </View>
    </Screen>
  );
};
